import React from "react";
import { Link } from "react-router-dom";
// import ChatBot from "../ChatBot/ChatBot";
import Avatar from "../misc/Avatar";
// import ChatBot2 from "../ChatBot/ChatBot2";
import ThemeToggleButton from "../misc/Theme/ThemeToggleButton ";
// import ReleaseNote from "../misc/temp/ReleaseNote";
import { useTheme } from "../../context/ThemeContext";
import ChatBotCD from "../ChatBot/ChatBotCD";
import { useLocation } from "react-router-dom";

const Navbar = () => {
    const { theme } = useTheme();
    const location = useLocation();

    return (
        <>
            <div
                className={`navbar mt-0 mb-20 container mx-auto shadow rounded-lg no-underline kanit-regular ${
                    location.pathname === "/chatbot" ? "hidden" : ""
                } ${theme === "dark" ? "bg-black" : "bg-white"}`}
            >
                <div className="navbar-start">
                    <div className="dropdown">
                        <button
                            tabIndex={0}
                            className="btn btn-ghost lg:hidden"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-7 w-7"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M4 6h16M4 12h8m-8 6h16"
                                />
                            </svg>
                        </button>
                        <ul
                            tabIndex={0}
                            className={`menu menu-sm dropdown-content rounded-box z-[1] mt-3 w-52 p-2 shadow ${
                                theme === "dark" ? "bg-black" : "bg-white"
                            } `}
                        >
                            {/* <li>
                                <Link to="/home" className="text-l mx-2">
                                    Home
                                </Link>
                            </li> */}
                            <li>
                                <Link to="/profile" className="text-l mx-2">
                                    Profile
                                </Link>
                            </li>
                            <li>
                                <Link to="/projects" className="text-l mx-2">
                                    Projects
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog" className="text-l mx-2">
                                    Blog
                                </Link>
                            </li>
                            <li>
                                <Link to="resume" className="text-l mx-2">
                                    Resume
                                </Link>
                            </li>
                            <li>
                                <Link to="connect" className="text-l mx-2">
                                    Connect
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="hidden md:flex lg:flex cursor-pointer transform transition duration-300 hover:scale-110 ">
                        <Avatar
                            address={`${
                                theme === "dark"
                                    ? "/media/icons/m-w.png"
                                    : "/media/icons/m-b.png"
                            }`}
                        />
                    </div>
                </div>
                <div className="navbar-center hidden lg:flex">
                    <ul className="menu menu-horizontal px-1">
                        {/* <li>
                            <Link
                                to="/home"
                                className="text-l mx-2 cursor-pointer transition-transform duration-200 transform hover:scale-110"
                            >
                                Home
                            </Link>
                        </li> */}
                        <li>
                            <Link
                                to="/profile"
                                className="text-xl mx-2 cursor-pointer transition-transform duration-200 transform hover:scale-110 "
                            >
                                Profile
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/projects"
                                className="text-xl mx-2 cursor-pointer transition-transform duration-200 transform hover:scale-110 "
                            >
                                Projects
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="blog"
                                className="text-xl mx-2 cursor-pointer transition-transform duration-200 transform hover:scale-110"
                            >
                                Blog
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="resume"
                                className="text-xl mx-2 cursor-pointer transition-transform duration-200 transform hover:scale-110"
                            >
                                Resume
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="connect"
                                className="text-xl mx-2 cursor-pointer transition-transform duration-200 transform hover:scale-110"
                            >
                                Connect
                            </Link>
                        </li>
                    </ul>
                </div>

                <div className="navbar-end">
                    {/* <ReleaseNote /> */}
                    {/* <ChatBot /> */}
                    <div className={`flex justify-center  `}>
                        <ChatBotCD />
                    </div>
                    <ThemeToggleButton />
                </div>
            </div>
        </>
    );
};

export default Navbar;
